import axios from 'axios'

const state = () => ({
  carusel: []
})

const getters = {
  carusel(state) {
    return state.carusel
  }
}

const mutations = {
  SET_CARUSEL(state, payload){
    state.carusel = payload
  },
  DELETE_CARUSEL(state, id){
    state.carusel = state.carusel.filter((x) => x.id != id);
  },
  ADD_CARUSEL(state, data){
    state.carusel.push(data)
  },
  EDIT_CARUSEL(state, data){
    state.carusel = state.carusel.map((vm)=>{
      if(vm.id == data.id){ return data}
      else{ return vm }
    })
  }
}

const actions = {
  getCarusel({commit}){
    axios.get('https://api.geomalaka.uz/api/main/carusel/')
    .then((res)=>{
      commit("SET_CARUSEL", res.data)
      // this._vm.$toast('Successful', {type: 'success'})
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  deleteCarusel({commit}, id){
    axios.delete(`https://api.geomalaka.uz/api/main/carusel/${id}/`)
    .then((res)=>{
      commit("DELETE_CARUSEL", id)
      this._vm.$toast('Deleted', {type: 'success'})
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  addCarusel({commit}, payload){
    axios.post('https://api.geomalaka.uz/api/main/carusel/', payload)
    .then((res)=>{
      commit("ADD_CARUSEL", res.data)
      this._vm.$toast(res.statusText, {type: 'success'});
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },
  editCarusel({commit}, payload){
    axios.put(`https://api.geomalaka.uz/api/main/carusel/${payload.id}/`, payload.data)
      .then((res)=>{
        commit("EDIT_CARUSEL", res.data)
        this._vm.$toast('Successful', {type: 'success'})
      })
      .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  }
}

export default{
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

